import { useCallback, useState } from "react";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { ChatModal } from "@/components/modals/ChatModal";

export function SiteLayout({ children, onOpenChat: onOpenChatProp }) {
  const [chatOpen, setChatOpen] = useState(false);

  const openChat = useCallback(() => {
    if (onOpenChatProp) {
      onOpenChatProp();
      return;
    }
    setChatOpen(true);
  }, [onOpenChatProp]);

  const closeChat = useCallback(() => setChatOpen(false), []);

  return (
    <div className="font-sans text-ink antialiased bg-white selection:bg-brand-100 selection:text-ink selection:text-white">
      <Header onOpenChat={openChat} />
      <main>{children}</main>
      <Footer />
      {!onOpenChatProp && <ChatModal open={chatOpen} onClose={closeChat} />}
    </div>
  );
}
